<div class="modal-body text-center p-5">
  <!-- FRC-858: withdrawal confirmation — icon, amount, and a Current/Withdrawal/
       Remaining balance summary. -->
  <div class="d-flex justify-content-center tw-mb-3">
    <div
      class="tw-flex tw-items-center tw-justify-center tw-rounded-full"
      style="width: 64px; height: 64px; background: #fdecec"
    >
      <!-- FRC-858: withdrawal (export-arrow) icon, matching the Withdraw modal header. -->
      <svg
        aria-hidden="true"
        focusable="false"
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#c1272d"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
        <path d="M16 17l5-5-5-5" />
        <path d="M21 12H9" />
      </svg>
    </div>
  </div>

  <h4 class="font-weight-extrabold tw-mb-3" style="color: #1a1a1a; font-size: 1.5rem">
    {{ 'mysec.confirmWithdrawalTitle' | translate }}
  </h4>

  <!-- "You are withdrawing" with divider lines -->
  <div class="tw-mb-2 tw-flex tw-items-center tw-gap-3">
    <span class="tw-h-px tw-flex-1" style="background: #e7e7e7"></span>
    <span class="tw-text-sm" style="color: #9aa2ab">{{ 'mysec.youAreWithdrawing' | translate }}</span>
    <span class="tw-h-px tw-flex-1" style="background: #e7e7e7"></span>
  </div>

  <div class="font-weight-extrabold text-primary tw-mb-4" style="font-size: 2.5rem; line-height: 1.1">
    {{ amount | numberSuffix: { numberFormat: '1.2-2' } }}
  </div>

  <!-- Summary: current balance, withdrawal amount, remaining balance -->
  <div class="tw-mb-5 tw-rounded-xl tw-px-4 tw-py-3 tw-text-left" style="background: #f5f7f6">
    <div class="tw-flex tw-justify-between tw-py-1 tw-text-sm">
      <span style="color: #6b7280">{{ 'mysec.currentBalance' | translate }}</span>
      <span style="color: #1a1a1a">{{ balance | numberSuffix: { numberFormat: '1.2-2' } }}</span>
    </div>
    <div class="tw-flex tw-justify-between tw-py-1 tw-text-sm">
      <span style="color: #6b7280">{{ 'mysec.withdrawalAmountLabel' | translate }}</span>
      <span class="text-primary">- {{ amount | numberSuffix: { numberFormat: '1.2-2' } }}</span>
    </div>
    <div class="tw-my-1 tw-border-t" style="border-color: #e0e4e2"></div>
    <div class="tw-flex tw-justify-between tw-py-1 font-weight-extrabold">
      <span style="color: #1a1a1a">{{ 'mysec.remainingBalance' | translate }}</span>
      <span style="color: #1a1a1a">{{ newBalance | numberSuffix: { numberFormat: '1.2-2' } }}</span>
    </div>
    <!-- FRC-858: explains the remaining balance rather than adding to the sum, so the
         column still totals to a real balance. Hidden when nothing is on hold. -->
    @if (onHoldAfter > 0) {
      <div class="tw-flex tw-pl-3 tw-text-xs" style="color: #6b7280">
        <span aria-hidden="true" class="tw-mr-1">&#8627;</span>
        <span>
          {{
            'mysec.remainingOnHoldNote'
              | translate: { amount: (onHoldAfter | numberSuffix: { numberFormat: '1.2-2' }) }
          }}
        </span>
      </div>
    }
  </div>

  <div class="d-flex flex-column">
    <button
      type="button"
      class="btn btn-primary font-weight-extrabold tw-flex tw-items-center tw-justify-center tw-gap-2"
      (click)="confirm()"
    >
      <svg
        aria-hidden="true"
        focusable="false"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <rect x="5" y="11" width="14" height="10" rx="2" />
        <path d="M8 11V7a4 4 0 0 1 8 0v4" />
      </svg>
      {{ 'mysec.confirmWithdrawalTitle' | translate }}
    </button>
    <button type="button" class="btn btn-grey font-weight-extrabold" (click)="cancel()">
      {{ 'common.back' | translate }}
    </button>
  </div>
</div>
